module.exports = __webpack_public_path__ + "img/elife_yuzhe_2021.71531000.jpg";